import { Grid, TextField, Typography } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { useForm } from "react-hook-form";
import { AnswersProps } from "../../app/models/Answers";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  professionalism: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const IndicatorsProfessionalism: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const { user } = useAppSelector((state) => state.account);

  const defaultValues = {
    professionalism: answersData.find((answer) => answer.systemCodeId === 255)
      ?.answer,
  };

  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderIndicatorsofProfessionalismCompetence = () => {
    return (
      <>
        <li>
          How do you represent both yourself and your company in a positive way
          at work and in your community?
        </li>
      </>
    );
  };

  return (
    <Grid container p={2} spacing={2}>
      <Grid item xs={12}>
        <Typography fontSize={18} fontWeight={700}>
          CS VI-b – Indicators of Professionalism
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>
          What do you believe are the most important indicators of
          professionalism that you possess?
        </Typography>
        {user?.credentialTypeId === 4 ? (
          <></>
        ) : (
          <ReadMoreReadLess>
            <>{renderIndicatorsofProfessionalismCompetence()}</>
          </ReadMoreReadLess>
        )}
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="I believe the most important indicators of my professionalism are"
          {...register("professionalism")}
          name="professionalism"
          fullWidth
          multiline
          rows={2}
          value={
            answersData.find((answer) => answer.systemCodeId === 255)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 255;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.professionalism?.message}
          helperText={errors.professionalism?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.professionalism?.length}/500
        </Typography>
      </Grid>
    </Grid>
  );
};
export default IndicatorsProfessionalism;
